"use client";

import { useState, useRef, DragEvent, ChangeEvent } from "react";

export default function FileUploader({ setFiles, files }) {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prev) => [...prev, ...droppedFiles]);
  };

  const handleFileInput = (e) => {
    if (e.target.files) {
      const selectedFiles = Array.from(e.target.files);
      setFiles((prev) => [...prev, ...selectedFiles]);
    }
  };

  const removeFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="max-w-4xl mx-auto py-2 bg-white rounded-3xl">
      <div className="grid md:grid-cols-2 gap-6">
        {/* Drag & Drop Area */}
        <div
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          className={`
            border border-[#dbdbdb] rounded-lg p-8 bg-white
            flex flex-col items-center justify-center
            transition-colors cursor-pointer
            ${isDragging ? "border-[#27004a] bg-white" : "border-[#27004a]"}
          `}
          onClick={() => fileInputRef.current?.click()}
        >
          {/* File Icon */}
          <svg
            className="w-10 h-10  text-[#27004a] mb-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <path d="M14 2v6h6" />
            <path d="M12 18v-6" />
            <path d="M8 15h8" />
          </svg>

          <p className="text-lg text-gray-600 text-center mb-2">
           Click here to upload file
          </p>
        
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileInput}
            className="hidden"
            multiple
          />
        </div>

        {/* Files Preview Area */}
        <div className="border-[#dbdbdb] border rounded-lg p-8 flex flex-col custom-scrollbar">
          <h2 className="text-[18px]  font-medium mb-4">Uploaded Files</h2>
          {files.length === 0 ? (
            <p className="text-gray-500 text-center flex-grow flex items-center justify-center">
              No Files Uploaded Yet
            </p>
          ) : (
            <ul className="w-full space-y-2 overflow-auto max-h-[124px]">
              {files.map((file, index) => (
                <li
                  key={index}
                  className="flex items-center justify-between text-sm text-gray-600 bg-gray-100 p-2 rounded"
                >
                  <span className="truncate max-w-[80%]">{file.name}</span>
                  <button
                    type="button"
                    onClick={() => removeFile(index)}
                    className="text-red-500 hover:text-red-700 transition-colors"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* Save Button */}
      {/* <div className="mt-6 flex justify-end">
        <button
          className="px-8 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={files.length === 0}
        >
          Save
        </button>
      </div> */}
    </div>
  );
}
